/**
 * Textos del POS (español).
 *
 * Se declaran aqui y se inyectan con `mergeLocaleMessage` en `app.js` porque los
 * mensajes del resto de la app los publica el layout desde los archivos `lang/`
 * (window.localMessagesUpdate), y esta entrega no toca archivos fuera de
 * `Modules/QuickBooking/Resources/`. Namespace propio `pos.*`: no pisa ninguna
 * clave de `quick_booking.*` usada por el flujo de reserva.
 */
export default {
  // Cabecera
  lbl_pos: 'Punto de venta',
  lbl_branch: 'Sucursal',
  lbl_select_branch: 'Selecciona una sucursal',
  lbl_cash_register_open: 'Caja abierta',
  lbl_cash_register_closed: 'Sin caja abierta',
  lbl_cash_register_warning: 'No hay caja abierta en esta sucursal: la venta en efectivo se registrara, pero no generara movimiento de caja.',
  lbl_reload_catalog: 'Recargar catalogo',
  lbl_reload: 'Recargar',
  lbl_loading: 'Cargando...',
  lbl_next_invoice: 'Prox. factura',
  lbl_offline: 'Sin conexion',
  lbl_online: 'En linea',
  lbl_cached_catalog: 'Catalogo en cache',
  lbl_sync: 'Sincronizar',
  lbl_offline_sale_title: 'Venta guardada sin conexion',
  lbl_offline_sale_help: 'El efectivo ya se cobro. La venta se registrara y facturara automaticamente al recuperar la conexion (boton Sincronizar).',
  lbl_conflicts: 'Conflictos',
  lbl_conflicts_help: 'Ventas offline que el servidor rechazo al sincronizar (p.ej. sin stock). Reintenta tras corregir, o descarta.',
  lbl_retry: 'Reintentar',
  lbl_discard: 'Descartar',
  lbl_consumidor_final: 'Consumidor Final',

  // Caja
  lbl_cash: 'Caja',
  lbl_open_short: 'Abierta',
  lbl_closed_short: 'Cerrada',
  lbl_cash_closed_title: 'Caja cerrada',
  lbl_cash_closed_help: 'Abre la caja para registrar las ventas en efectivo y los ingresos/egresos de dinero.',
  lbl_cash_open_title: 'Caja abierta',
  lbl_cash_movements: 'Ingresos / Egresos de efectivo',
  lbl_opening_amount: 'Monto de apertura',
  lbl_expected_amount: 'Efectivo esperado',
  lbl_open_cash: 'Abrir caja',
  lbl_movement_amount: 'Monto',
  lbl_movement_note: 'Concepto (opcional)',
  lbl_cash_in: 'Ingreso',
  lbl_cash_out: 'Egreso',
  lbl_cash_movements_list: 'Movimientos registrados',
  lbl_pay_card_credit: 'Tarjeta crédito',
  lbl_pay_card_debit: 'Tarjeta débito',
  lbl_pay_datafast_voucher: 'Datafast (voucher)',
  lbl_voucher: 'Datos del voucher',
  lbl_voucher_brand: 'Marca (Visa)',
  lbl_voucher_last4: 'Últimos 4',
  lbl_voucher_auth: 'Autorización',
  lbl_voucher_batch: 'Lote',
  lbl_call_order: 'Llamar orden',
  lbl_order_loaded: 'Cobrando orden #{id}',
  lbl_open_orders: 'Órdenes abiertas',
  lbl_open_orders_help: 'Citas en curso que todavía no se cobran.',
  lbl_no_open_orders: 'No hay órdenes abiertas. Se abren al hacer check-in de una cita.',
  lbl_cash_receipt: 'Recibo',
  lbl_cash_type_income: 'Ingreso',
  lbl_cash_type_expense: 'Egreso',
  lbl_cash_type_sale: 'Venta',
  lbl_cash_type_tip: 'Propina',
  lbl_cash_sales: 'Ventas en efectivo',
  // Pago dividido (multi-tender)
  lbl_split: 'Dividir pago',
  lbl_split_help: 'Reparte el total en varios medios (efectivo, transferencia, cheque o pasarela). Los medios de pasarela piden referencia. La suma debe cuadrar con el total.',
  lbl_split_no_tip: 'El pago dividido no admite propina.',
  lbl_split_ref_required: 'Cada medio de pasarela necesita su referencia.',
  lbl_split_balanced: 'Cuadra',
  lbl_split_remaining: 'Por repartir',
  lbl_split_sum: 'Suma',
  lbl_split_no_tenders: 'El pago dividido no admite cupón, puntos, monedero ni gift card.',
  lbl_split_unbalanced: 'Los pagos deben sumar exactamente el total.',
  lbl_add_tender: 'Añadir medio',
  lbl_fill_last: 'Repartir resto',
  lbl_edit: 'Editar',
  lbl_line_discount: 'Desc. línea',
  // Reporte X del dia
  lbl_daily_report: 'Reporte del día',
  lbl_date: 'Fecha',
  lbl_sales_count: 'Ventas',
  lbl_gross_total: 'Total bruto',
  lbl_by_method: 'Por método de pago',
  lbl_breakdown: 'Desglose',
  lbl_products_revenue: 'Productos',
  lbl_services_revenue: 'Servicios',
  lbl_packages_revenue: 'Paquetes',
  lbl_tips: 'Propinas',
  lbl_no_sales: 'Sin ventas en la fecha.',
  lbl_close: 'Cerrar',
  msg_generic_error: 'Ocurrió un error. Intenta de nuevo.',
  lbl_close_cash: 'Cerrar caja (arqueo)',
  lbl_cash_count: 'Arqueo de caja',
  lbl_counted_amount: 'Efectivo contado',
  lbl_difference: 'Diferencia',
  lbl_confirm_close: 'Confirmar cierre',
  lbl_cash_closed_done: 'Caja cerrada',

  // Sesion / permisos
  lbl_unauthenticated: 'Tu sesion no esta activa. Inicia sesion en el panel para usar el punto de venta.',
  lbl_forbidden: 'Tu usuario no tiene permiso de reservas (view_booking / add_booking) para usar el punto de venta.',

  // Cliente
  lbl_customer: 'Cliente',
  lbl_search_customer: 'Buscar cliente',
  lbl_search_customer_ph: 'Nombre, telefono, cedula, RUC o email',
  lbl_search: 'Buscar',
  lbl_no_customers: 'Sin resultados. Puedes crear el cliente.',
  lbl_new_customer: 'Cliente nuevo',
  lbl_cancel: 'Cancelar',
  lbl_create: 'Crear cliente',
  lbl_change_customer: 'Cambiar',
  lbl_first_name: 'Nombres',
  lbl_last_name: 'Apellidos',
  lbl_identification_type: 'Tipo de identificacion',
  lbl_identification: 'Identificacion',
  lbl_id_cedula: 'Cedula',
  lbl_id_ruc: 'RUC',
  lbl_id_pasaporte: 'Pasaporte',
  lbl_email: 'Email',
  lbl_mobile: 'Telefono',
  lbl_no_identification: 'Sin identificacion',
  lbl_final_consumer_warning: 'Se facturara como CONSUMIDOR FINAL; no se podra emitir nota de credito.',
  lbl_customer_required: 'Selecciona o crea un cliente para cobrar.',
  lbl_looking_up_receptor: 'Consultando identificacion...',

  // Entrega
  lbl_delivery: 'Entrega',
  lbl_pickup: 'Retiro en local',
  lbl_delivery_home: 'Envio a domicilio',
  lbl_delivery_customer_first: 'Selecciona un cliente para elegir su direccion de envio.',
  lbl_shipping_address: 'Direccion de envio',
  lbl_select_address: 'Selecciona una direccion',
  lbl_primary_address: 'Principal',
  lbl_no_addresses: 'Este cliente no tiene direcciones. Agrega una para poder enviarle.',
  lbl_add_address: 'Agregar direccion',
  lbl_save_address: 'Guardar direccion',
  lbl_address_line_1: 'Calle y numero',
  lbl_city: 'Ciudad',
  lbl_state: 'Provincia',
  lbl_delivery_note: 'Al cobrar se crea la orden de despacho con esta direccion. El costo de envio es informativo (no se cobra aqui).',
  lbl_delivery_created: 'Orden de despacho',
  lbl_delivery_order: 'Orden',

  // Catalogo
  lbl_catalog: 'Catalogo',
  lbl_services: 'Servicios',
  lbl_products: 'Productos',
  lbl_filter_ph: 'Filtrar por nombre...',
  lbl_no_services: 'Esta sucursal no tiene servicios activos.',
  lbl_no_products: 'No hay productos publicados.',
  lbl_stock: 'Stock',
  lbl_out_of_stock: 'Sin stock',
  lbl_min: 'min',
  lbl_all_categories: 'Todas',
  lbl_on_discount: 'Con descuento',
  lbl_scan_mode: 'Lectura',
  lbl_scan_ph: 'Escanea el codigo de barras...',
  lbl_scan_added: 'Anadido',

  // Carrito
  lbl_cart: 'Carrito',
  lbl_empty_cart: 'El carrito esta vacio. Añade servicios o productos.',
  lbl_employee: 'Empleado',
  lbl_select_employee: 'Selecciona empleado',
  lbl_no_employees: 'Sin empleados para este servicio en la sucursal.',
  lbl_date_time: 'Fecha y hora',
  lbl_qty: 'Cantidad',
  lbl_remove: 'Quitar',
  lbl_clear_cart: 'Vaciar',
  lbl_employee_required: 'Cada servicio necesita un empleado asignado.',
  lbl_stock_exceeded: 'La cantidad supera el stock disponible.',
  lbl_note: 'Nota',
  lbl_note_ph: 'Nota interna de la venta (opcional)',

  // Totales
  lbl_totals: 'Totales',
  lbl_subtotal_services: 'Servicios',
  lbl_subtotal_products: 'Productos',
  lbl_subtotal: 'Subtotal',
  lbl_tax: 'Impuestos',
  lbl_tip: 'Propina',
  lbl_total: 'Total',
  lbl_estimated: 'Estimado',
  lbl_estimate_notice: 'Importes estimados. El total definitivo (cupon, puntos, monedero y gift card) lo calcula y confirma el servidor al cobrar.',

  // Descuentos vs medios de pago (distincion fiscal)
  lbl_discounts: 'Descuentos',
  lbl_discounts_help: 'Reducen la base imponible: bajan el IVA de la factura.',
  lbl_coupon: 'Cupon',
  lbl_coupon_ph: 'Codigo del cupon',
  lbl_discount: 'Descuento',
  lbl_manual_discount: 'Descuento manual (% o importe)',
  lbl_discount_coupon_conflict: 'El descuento manual no se combina con un cupon: usa uno u otro.',
  lbl_package_pending: 'La sesion de paquete tambien reduce la base imponible, pero aun no se puede seleccionar aqui: falta un endpoint que liste el saldo de paquetes del cliente.',
  lbl_tenders: 'Pagado con',
  lbl_tenders_help: 'Son medios de pago: reducen lo que se cobra, NO reducen el IVA.',
  lbl_points: 'Puntos',
  lbl_points_ph: 'Puntos a canjear',
  lbl_wallet: 'Monedero',
  lbl_wallet_ph: 'Importe del monedero',
  lbl_gift_card: 'Gift card',
  lbl_gift_card_ph: 'Codigo de la gift card',
  lbl_server_resolves: 'El servidor valida el saldo y el importe exacto.',

  // Cobro
  lbl_payment: 'Cobro',
  lbl_payments: 'Cobros',
  lbl_payments_help: 'Elige el medio de pago. Añade más de uno para un pago múltiple; la suma debe cuadrar con el total.',
  lbl_payment_method: 'Medio de pago',
  lbl_pay_cash: 'Efectivo',
  lbl_pay_transfer: 'Transferencia',
  lbl_pay_deposito: 'Depósito',
  lbl_pay_cheque: 'Cheque',
  lbl_pay_payphone: 'PayPhone',
  lbl_pay_datafast: 'Datafast',
  lbl_pay_deuna: 'DeUna',
  lbl_pay_kushki: 'Kushki',
  lbl_pay_stripe: 'Stripe',
  lbl_pay_paypal: 'PayPal',
  lbl_pay_datafast: 'Pago con tarjeta (Datafast)',
  lbl_datafast_pay: 'Cobrar con Datafast',
  lbl_datafast_ready: 'Pago Datafast recibido. Confirma la venta para verificarlo.',
  lbl_datafast_widget_help: 'Ingresa los datos de la tarjeta. Al aprobarse, vuelves al POS para confirmar la venta.',
  lbl_reference: 'Referencia del cobro',
  lbl_reference_ph: 'ID de la transaccion del datafono/pasarela',
  lbl_reference_required: 'La pasarela exige la referencia del cobro ya capturado.',
  lbl_reference_help: 'El servidor verifica esta referencia con la pasarela antes de registrar la venta.',
  lbl_drawer_note: 'Entra al cajon: genera movimiento de caja.',
  lbl_offline_note: 'Se liquida fuera de pasarela: el cajero ya tiene el dinero.',
  lbl_invoice: 'Emitir factura SRI',
  lbl_invoice_help: 'Se emite despues de registrar la venta. Si falla, la venta cobrada NO se pierde.',
  lbl_charge: 'Cobrar',
  lbl_send_to_cashier: 'Enviar a caja',
  lbl_sending: 'Enviando...',
  lbl_sent_to_cashier: 'Orden enviada a caja. La encargada la verá en «Llamar orden» para cobrarla.',
  lbl_send_only_info: 'Arma la venta y envíala a caja: la cobra la encargada.',
  lbl_charging: 'Cobrando...',
  lbl_done: 'Listo',
  lbl_invoice_number: 'Factura N.',
  lbl_cash_received: 'Efectivo recibido',
  lbl_exact: 'Exacto',
  lbl_clear: 'Limpiar',
  lbl_change: 'Cambio',
  lbl_missing: 'Faltan',

  // Resultado
  lbl_sale_registered: 'Venta registrada',
  lbl_sale_number: 'Venta',
  lbl_payment_status: 'Estado del pago',
  lbl_status_paid: 'PAGADO',
  lbl_status_unpaid: 'NO PAGADO',
  lbl_gateway_verified: 'Verificado con la pasarela',
  lbl_amount_due: 'Importe cobrado',
  lbl_cash_movement: 'Movimiento de caja',
  lbl_points_used: 'Puntos usados',
  lbl_wallet_used: 'Monedero usado',
  lbl_gift_card_applied: 'Gift card aplicada',
  lbl_coupon_discount: 'Descuento por cupon',
  lbl_taxable_base: 'Base imponible',
  lbl_new_sale: 'Nueva venta',
  lbl_print_receipt: 'Imprimir recibo',
  lbl_hold: 'En espera',
  lbl_resume: 'Retomar',
  lbl_held_orders: 'Ordenes en espera',
  lbl_no_holds: 'No hay ordenes en espera.',

  // Factura SRI
  lbl_invoice_status: 'Factura SRI',
  lbl_invoice_authorized: 'AUTORIZADA',
  lbl_invoice_pending: 'PENDIENTE',
  lbl_invoice_rejected: 'NO AUTORIZADA',
  lbl_invoice_error: 'ERROR DE EMISION',
  lbl_invoice_not_requested: 'No se solicito factura',
  lbl_invoice_pending_help: 'El comprobante se envio pero el SRI aun no responde autorizacion. Reconsulta desde el modulo SRI.',
  lbl_invoice_error_help: 'La venta esta cobrada y registrada. Puedes reintentar la emision desde el modulo SRI.',
  lbl_access_key: 'Clave de acceso',
  lbl_authorization: 'Autorizacion',
  lbl_view_ride: 'Ver RIDE',

  // Errores
  lbl_error: 'Error',
  lbl_unexpected_error: 'No se pudo completar la operacion.'
}
